import React, { Component } from 'react'
import { connector, ConfirmStateProps } from './Confirm.state'
import Notify from '../Notify'

export interface ConfirmProps {}

type ConfirmCombinedProps = ConfirmProps & ConfirmStateProps

class Confirm extends Component<ConfirmCombinedProps> {
  render () {
    return (
      <Notify
        visible={this.props.visible}
        type={this.props.type}
        message={this.props.question}>
        <div className="inline-flex ml-8">
          <button
            className="font-medium focus:outline-none"
            onClick={this.props.cancel}>
            {this.props.cancelText}
          </button>
          <button
            className="ml-3 font-medium focus:outline-none"
            onClick={this.props.confirm}>
            {this.props.confirmText}
          </button>
        </div>
      </Notify>
    )
  }
}

export default connector(Confirm)
